import React, { useCallback, useMemo } from 'react';
import { PropTypes } from 'prop-types';
import { Icon, Link as LinkButton } from '@ontruck/orc';
import { useTranslation } from 'react-i18next';
import { useOrder } from 'hooks/useOrders';
import {
  actions as analyticsActions,
  constants as analyticsEvents,
} from 'state/analytics';
import routes from 'utils/routes';
import { useDispatch } from 'react-redux';
import { history } from 'state/store';
import LoadsSummaryInline from 'refactored/features/order/loads/displays/LoadsSummaryInline';
import Tag from 'components/Tag';
import { IS_TENANT } from 'tenant/utils';
import LoadsSummaryInlineTenant from 'refactored/features/order/loads/displays/LoadsSummaryInlineTenant';

const Header = ({ className, orderId }) => {
  const { t } = useTranslation('ModalOrderDetail');
  const dispatch = useDispatch();
  const { order, loads } = useOrder(orderId);

  let typeForTenant = null;
  if (order.journey_type === 'COLLECTION') {
    typeForTenant = 'Exportación';
  } else if (order.journey_type === 'DISTRIBUTION') {
    typeForTenant = 'Importación';
  }
  const { recurringOrderId, createdBy } = useMemo(
    () => ({
      recurringOrderId: order.recurring_order_id,
      createdBy: order.user?.name,
    }),
    [order]
  );

  const goToRecurringOrderDetail = useCallback(() => {
    dispatch(
      analyticsActions.sendEvent(
        analyticsEvents.recurringOrderConfigurationOpened({
          recurringOrderId,
          orderId,
        })
      )
    );
    history.push(`${routes.orders.recurring}/${recurringOrderId}`);
  }, [dispatch, orderId, recurringOrderId]);

  return (
    <div className={className}>
      <div className="reference">
        <span className="label">{t('header.label')}</span>
        <span data-e2e="shipmentId" className="shipmentId">
          {`S${orderId}`}
        </span>
      </div>
      <div className="info">
        {IS_TENANT && <Tag label={typeForTenant} />}
        <span className="shipmentId">
          {t('header.shipmentId', { orderId })}
        </span>
        {!IS_TENANT && (
          <span data-e2e="numberOfItems" className="type">
            <LoadsSummaryInline loads={loads} />
          </span>
        )}
        {IS_TENANT && (
          <span data-e2e="numberOfItems" className="type">
            <LoadsSummaryInlineTenant order={order} />
          </span>
        )}
        {recurringOrderId ? (
          <span className="recurring">
            <Icon glyph="recurring" color="grey500" size="24px" />
            <LinkButton
              text={t('header.recurring_order')}
              size="L"
              skin="secondary"
              onClick={goToRecurringOrderDetail}
            />
          </span>
        ) : (
          <span data-e2e="createdBy" className="creation">
            {t('header.creation', { createdBy })}
          </span>
        )}
      </div>
    </div>
  );
};

Header.propTypes = {
  orderId: PropTypes.string.isRequired,
};

export default Header;
